import processDlg from './processDlg.js'

const processBase = {
  namespaced: true,
  modules: {
    processDlg
  }
}

export default processBase
